module.exports = __webpack_public_path__ + "static/img/RU.b642b930.png";